import React from 'react';
import { useHistory } from 'react-router-dom';
import { MGMENT_DASHBOARD_ROUTE } from '../../routes/routes';

function DashboardLanding() {
  const history = useHistory();
  return <div>{history.push(MGMENT_DASHBOARD_ROUTE)}</div>;
}

export default DashboardLanding;
